import { useMemo } from 'react';
import { TDashboardUserPermissions } from '../Dashboard';
import { useCosmos } from 'providers/contexts/CosmosContext';
import {
  checkSiteAdminPermission,
  getDashboardGroupPermissions,
} from 'utility/permissions';

export default function useDashboardPermissions() {
  const { sessionConfig, userInfo } = useCosmos();
  const isSuperUser = Boolean(userInfo?.account_type === 'staff');
  const { granted: isAdmin } = checkSiteAdminPermission(sessionConfig);

  const permissions = useMemo(
    () => getDashboardGroupPermissions(sessionConfig),
    [sessionConfig],
  );

  return {
    create: isSuperUser || isAdmin || permissions.create.granted,
    edit: isSuperUser || permissions.edit.granted,
    delete: isSuperUser || isAdmin || permissions.delete.granted,
    share: isSuperUser || permissions.share.granted,
    full: isSuperUser || isAdmin || permissions.full.granted,
  } as TDashboardUserPermissions;
}
